import React from 'react'
import {
    Checkbox as ChakraCheckbox,
    useStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {CheckboxCheckIcon} from '../icons/shared'
import PropTypes from 'prop-types'

const CustomCheckIcon = (props) => {
    const {isChecked, ...rest} = props
    if (!isChecked) return null
    return <CheckboxCheckIcon {...rest} />
}

CustomCheckIcon.propTypes = {
    isChecked: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
}

const Checkbox = React.forwardRef((props, ref) => {
    const styles = useStyleConfig('Checkbox', {variant: props.variant})
    const controlSx = props?.sx?.['.chakra-checkbox__control']
    return (
        <ChakraCheckbox
            {...props}
            ref={ref}
            sx={{
                ...styles,
                ...(props?.sx || {}),
                ...(props?.isError && {
                    '.chakra-checkbox__control': {
                        ...(controlSx || {}),
                        borderColor: 'text.danger',
                    },
                }),
            }}
            icon={<CustomCheckIcon isChecked={props.isChecked} />}
        />
    )
})
Checkbox.displayName = 'Checkbox'

Checkbox.propTypes = {
    isChecked: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    isDisabled: PropTypes.bool,
    onChange: PropTypes.func,
    children: PropTypes.node,
    variant: PropTypes.string,
    isError: PropTypes.bool,
    sx: PropTypes.object,
}

export default Checkbox
